/**
 * yuna-product-name-fit.js — keeps each line of the product page title inside its column.
 *
 * The title lines (snippets/yuna-product-name.liquid) are set in script and display
 * faces at a fixed size per breakpoint, and a long name — "Kit Trio" in Milova at
 * 104px on a phone — ran past the edge and was cut off. Only a line whose text is
 * wider than the column shrinks, by exactly the ratio it overflows.
 *
 * It is an asset rather than an inline script after the heading on purpose: that
 * <script> became the heading's next sibling and broke the template's
 * `.yuna-product-name + .group-block` rule, which keeps the price and the unit
 * badge on one row on small phones.
 */
(function () {
  'use strict';

  function availableWidth(heading) {
    var column = heading.parentElement;
    if (!column) return 0;
    var columnStyle = getComputedStyle(column);
    var headingStyle = getComputedStyle(heading);
    return (
      column.clientWidth -
      parseFloat(columnStyle.paddingLeft) -
      parseFloat(columnStyle.paddingRight) -
      parseFloat(headingStyle.paddingLeft) -
      parseFloat(headingStyle.paddingRight)
    );
  }

  function fit(heading, force) {
    var available = availableWidth(heading);
    if (available <= 0) return;
    if (!force && Math.abs(available - (heading.__yunaFitWidth || -1)) < 1) return;
    heading.__yunaFitWidth = available;

    var range = document.createRange();
    var lines = heading.querySelectorAll('.yuna-product-name__line');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      line.style.removeProperty('font-size');
      // The lines are block-level, so their own boxes always span the heading;
      // the range measures the text itself.
      range.selectNodeContents(line);
      var textWidth = range.getBoundingClientRect().width;
      if (textWidth > available) {
        var size = parseFloat(getComputedStyle(line).fontSize) * (available / textWidth);
        line.style.setProperty('font-size', Math.floor(size) + 'px', 'important');
      }
    }
  }

  var observer = window.ResizeObserver
    ? new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var headings = entries[i].target.querySelectorAll('.yuna-product-name');
          for (var j = 0; j < headings.length; j++) {
            if (headings[j].parentElement === entries[i].target) fit(headings[j], false);
          }
        }
      })
    : null;

  function init() {
    var headings = document.querySelectorAll('.yuna-product-name');
    if (!headings.length) return;

    for (var i = 0; i < headings.length; i++) {
      fit(headings[i], true);
      if (observer && headings[i].parentElement) observer.observe(headings[i].parentElement);
    }

    // Web fonts change the width of every line once they arrive.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        for (var j = 0; j < headings.length; j++) fit(headings[j], true);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: a re-rendered section brings a fresh heading.
  document.addEventListener('shopify:section:load', init);
})();
